import { render, staticRenderFns } from "./AddProductDetails.vue?vue&type=template&id=65c79cec"
var script = {}
import style0 from "./AddProductDetails.vue?vue&type=style&index=0&id=65c79cec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports